module.exports = __webpack_public_path__ + "img/20180204175731.80dd4727.jpg";